import { render, staticRenderFns } from "./EdenAvatar.vue?vue&type=template&id=691bfce4&scoped=true"
import script from "./EdenAvatar.vue?vue&type=script&lang=js"
export * from "./EdenAvatar.vue?vue&type=script&lang=js"
import style0 from "./EdenAvatar.vue?vue&type=style&index=0&id=691bfce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691bfce4",
  null
  
)

export default component.exports